export const getPointsLocale = (item) => {
    return (item.getAttribute('data-locale') || 'баллов')
        .split(',')
        .map(item => item.trim());
}
